
(() => {
  const GUIDE_SELECTOR = '.size_guide_content[data-size-guide-unit]';

  function initializeGuide(guide) {
    if (guide.dataset.unitsInitialized === 'true') return;

    const table = guide.querySelector('table');
    const buttons = guide.querySelectorAll(
      '.size-guide-unit-button'
    );

    if (!table || buttons.length !== 2) return;

    const rows = Array.from(table.querySelectorAll('tr'));
    const measurements = [];

    rows.slice(1).forEach((row) => {
      const cells = Array.from(row.querySelectorAll('td'));

      // Skip the first column, which contains clothing sizes.
      cells.slice(1).forEach((cell) => {
        const original = cell.textContent.trim();
        const value = Number(original);

        if (original !== '' && Number.isFinite(value)) {
          measurements.push({
            cell,
            inches: value,
            original
          });
        }
      });
    });

    if (!measurements.length) return;

    guide.dataset.unitsInitialized = 'true';

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const unit = button.dataset.unit;
        if (unit !== 'in' && unit !== 'cm') return;

        measurements.forEach(({ cell, inches, original }) => {
          cell.textContent = unit === 'cm'
            ? (inches * 2.54).toFixed(1)
            : original;
        });

        buttons.forEach((item) => {
          const active = item.dataset.unit === unit;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });

        guide.dataset.sizeGuideUnit = unit;
      });
    });
  }

  function initializeAllGuides() {
    document.querySelectorAll(GUIDE_SELECTOR)
      .forEach(initializeGuide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeAllGuides
    );
  } else {
    initializeAllGuides();
  }

  // Support Shopify theme-editor section reloads.
  document.addEventListener(
    'shopify:section:load',
    initializeAllGuides
  );
})();
